import { msalInstance } from '../index'
import { AuthenticationResult } from '@azure/msal-common';
import { msalConfig } from '../msalConfig';


export const ApiScope = {
    scopes: [`${msalConfig.auth.clientId}/.default`]
};

export async function aquireAccessToken(scopes: any): Promise<AuthenticationResult> {
    const account = msalInstance.getActiveAccount();
    if (account === undefined || account === null) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        ...scopes,
        account
    });
    return response;
}

export const getRoles = () => {
    const account = msalInstance.getActiveAccount();
    return account?.idTokenClaims?.roles;
}

export const getAccessToken = async (scopes: any): Promise<string> => {
    const auth = await aquireAccessToken(scopes);
    return auth.accessToken
}


export const getTenantId = () => {
    const account = msalInstance.getActiveAccount();
    return account?.tenantId;
}

export const getUserId = () => {
    const account = msalInstance.getActiveAccount();
    return account?.localAccountId;
}

export const getHeaders = async (scopes: any, headers: any): Promise<any> => {
    const token = await getAccessToken(scopes,);
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
}

